import React, { useId } from "react";
import "./TextField.css";

const TextArea = React.forwardRef(function TextArea(
    {
        label,
        value,
        onChange,
        placeholder,
        hint,
        error,
        required,
        maxLength,
        rows = 3,
        disabled,
        ...rest
    },
    ref
) {
    const id = useId();
    const handle = (e) => onChange?.(e.target.value);
    const describedBy = error ? `${id}-err` : hint ? `${id}-hint` : undefined;
    const len = (value ?? "").length;

    return (
        <div className={`tfield ${error ? "tfield--invalid" : ""}`}>
            <label className="tfield__label uppercase-label" htmlFor={id}>
                {label}
                {required && <span className="tfield__req" aria-hidden="true">*</span>}
            </label>
            <textarea
                ref={ref}
                id={id}
                rows={rows}
                value={value ?? ""}
                onChange={handle}
                placeholder={placeholder}
                disabled={disabled}
                maxLength={maxLength}
                aria-invalid={error ? "true" : undefined}
                aria-describedby={describedBy}
                className="tfield__textarea focus-ring"
                {...rest}
            />
            {error ? (
                <span className="tfield__error" id={`${id}-err`} role="alert">
                    {error}
                </span>
            ) : (
                <div className="tfield__meta">
                    {hint && (
                        <span className="tfield__hint" id={`${id}-hint`}>
                            {hint}
                        </span>
                    )}
                    {maxLength && (
                        <span className="tfield__count mono-num">
                            {len}/{maxLength}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
});

export default TextArea;
